import { CheckCircle2 } from 'lucide-react-native';
import { Text, VStack } from '../../../components/primitives';
import { Button } from '../../../components/primitives/Button';
import { useTranslation } from '../../../contexts/TranslationContext';
import { colors } from '../../../theme/colors';

interface SuccessStepProps {
  onGoToAgents: () => void;
}

export function SuccessStep({ onGoToAgents }: Readonly<SuccessStepProps>) {
  const { t } = useTranslation();

  return (
    <VStack spacing="md" align="center" testID="onboarding-success-step">
      <CheckCircle2 size={48} color={colors.status.success.main} strokeWidth={2} />
      <Text variant="h4" color={colors.text.primary}>
        {t('onboardingWizard.success.title')}
      </Text>
      <Text variant="body" color={colors.text.secondary}>
        {t('onboardingWizard.success.subtitle')}
      </Text>
      <Button testID="onboarding-success-cta" variant="primary" onPress={onGoToAgents}>
        {t('onboardingWizard.success.cta')}
      </Button>
    </VStack>
  );
}
